module.exports = __webpack_public_path__ + "img/icon_close.b723b779.svg";